import { useCallback, useState } from "react";
import { useModal, useTermsAgreeMutation } from "@/hooks";
import TermAgreementForm from "@/components/Form/TermAgreementForm";
import { jsx as _jsx } from "react/jsx-runtime";
export default function TermsAgreementModal(_ref) {
  let {
    terms
  } = _ref;
  const {
    hideModal
  } = useModal();
  const {
    0: agreementError,
    1: setAgreementError
  } = useState();
  const [agree] = useTermsAgreeMutation({
    onCompleted: () => {
      hideModal();
    },
    onError: e => {
      setAgreementError(e.message);
    }
  });
  const onSubmit = useCallback(data => {
    if (data.terms) {}
    const keys = terms.filter(term => {
      if (data.terms && term.required) {
        return true;
      } else if (data.termsAd && term.id_key === "ad") {
        return true;
      } else if (data.termsMail && term.id_key === "spoox_mail") {
        return true;
      } else {
        return false;
      }
    }).map(term => term.current_revision.unique_key);
    agree({
      variables: {
        keys
      }
    });
  }, [terms]);
  return /*#__PURE__*/_jsx(TermAgreementForm, {
    onSubmit: onSubmit,
    terms: terms,
    agreementError: agreementError
  });
}